// The animated logo plays as a one-shot: once on load, then on a long interval,
// and on hover. It never loops continuously. If the video can't load or play,
// the text in header.php just stays.
const REPLAY_INTERVAL = 120000

const video = document.querySelector('[data-logo-video]')

if (video) {
  const logo = video.closest('.header-logo')

  // Reveal once the first frame is decoded so we never flash empty space.
  // Frame 0 is the plain wordmark (the "keep dancing" morph is mid-clip), so a
  // video that never plays still reads as the logo — which is what quiet-mode
  // visitors get.
  const reveal = () => logo?.classList.add('has-logo-video')
  video.addEventListener('loadeddata', reveal, { once: true })
  if (video.readyState >= 2) reveal()

  // Quiet mode is read here, at call time, not latched at startup: the visitor
  // can flip it mid-session and both the hover and the interval have to respect
  // the new answer. Playing from the start unless it's already running keeps a
  // hover mid-play from jumping back to frame 0.
  const play = () => {
    if (document.body.classList.contains('reduce-motion')) return
    if (!video.paused) return
    video.currentTime = 0
    video.play().catch(() => {})
  }

  logo?.addEventListener('mouseenter', play)
  play()
  setInterval(play, REPLAY_INTERVAL)

  // The one case the call-time check can't cover: quiet mode switched on while
  // the clip is already running. Stop it now rather than let it dance out.
  window.addEventListener('glunz:motionchange', e => {
    if (!e.detail.reduced) return
    video.pause()
    video.currentTime = 0
  })
}
